import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface TestTypeSelectorProps {
  value: "Endoscopy" | "Histology" | "GP Summary" | "Referral" | null;
  onChange: (value: "Endoscopy" | "Histology" | "GP Summary" | "Referral") => void;
  label: string;
  sequenceNumber: number | null;
  onLabelChange: (label: string) => void;
}

export function TestTypeSelector({ value, onChange, label, sequenceNumber, onLabelChange }: TestTypeSelectorProps) {
  return (
    <div className="space-y-2 w-full flex flex-row items-end justify-between gap-4">
      <div className="flex-1 min-w-0">
        <Label htmlFor="test_type">Test Type</Label>
        <RadioGroup value={value || ""} onValueChange={onChange} className="flex space-x-4">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Endoscopy" id="endoscopy" />
            <Label htmlFor="endoscopy">Endoscopy</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Histology" id="histology" />
            <Label htmlFor="histology">Histology</Label>
          </div>
          <div className="flex items-center space-x-2 bg-yellow-50 px-3 py-2 rounded-md border border-yellow-200">
            <RadioGroupItem value="GP Summary" id="gp-summary" />
            <Label htmlFor="gp-summary" className="text-yellow-800">
              GP Summary
            </Label>
          </div>
          <div className="flex items-center space-x-2 bg-purple-50 px-3 py-2 rounded-md border border-purple-200">
            <RadioGroupItem value="Referral" id="referral" />
            <Label htmlFor="referral" className="text-purple-800">
              Referral
            </Label>
          </div>
        </RadioGroup>
      </div>
      <div className="flex flex-col items-end min-w-[180px] gap-2">
        <div className="flex flex-row gap-2 w-full">
          <div className="flex flex-col items-end flex-1">
            <Label htmlFor="label" className="mb-1">
              Label
            </Label>
            <input
              id="label"
              type="text"
              value={label}
              onChange={(e) => onLabelChange(e.target.value)}
              placeholder="Enter label (optional)"
              className="border rounded px-2 py-1 w-full min-w-[120px]"
            />
          </div>
          <div className="flex flex-col items-end flex-1">
            <Label htmlFor="sequence_number" className="mb-1">
              Seq #
            </Label>
            <input
              id="sequence_number"
              type="number"
              value={sequenceNumber ?? ""}
              readOnly
              className="border rounded px-2 py-1 bg-gray-100 text-gray-700 cursor-not-allowed text-center"
              style={{ width: "auto", minWidth: 0, maxWidth: "60px" }}
              tabIndex={-1}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
